import React, { useState, useContext } from 'react';
import './RegionSelected.scss';
import { useHistory, useParams } from 'react-router-dom';
import CaletaSelected from './../CaletaSelected/CaletasSelected'
import LeafletMap from './../../common/Leaflet'
import flecha from '../../../assets/flecha.svg';
import regions from './../../sernapesca.json';
import { ResourcesContext } from '../../ContextProvider';
import { useEffect } from 'react';
import { uiContext } from '../../common';
import FisherPortal from '../../FisherPortal/FisherPortal';

function toTitleCase(str) {
    return str.replace(
        /\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}
/**
 * Componente de la región Seleccionada
 * Muestra los datos según la región que se ha seleccionado
 */
const RegionSelected = () => {
    const history = useHistory();
    const uicontext = useContext(uiContext);
    const resources = useContext(ResourcesContext);
    const [caleta, setCaleta] = useState({});
    const [caletas, setCaletas] = useState([])
    const [showCaletasList, setShowCaletasList] = useState(false);
    const [showCaleta, setShowCaleta] = useState(false);
    const [caletaId, setCaletaId] = useState('');
    const [markerPosition, setMarkerPosition] = useState({ lat: -33.440324, lng: -70.665975 });
    const [isCharged, setIsCharged] = useState(false);
    const [man, setMan] = useState(0);
    const [woman, setWoman] = useState(0);
    let { id, regionfilter } = useParams();
    let region = regions.find((r) => {
        return r.cdRegion == id
    })

    function selectCaleta(caleta, boolean) {
        
        setCaleta(caleta);
        setShowCaletasList(boolean)
        let position = {
            lat: caleta.caletaPOS ? caleta.caletaPOS[1] : -33.440324,
            lng: caleta.caletaPOS ? caleta.caletaPOS[0] : -70.665975
        }

        setMarkerPosition(position)
    }
    function toTitleCase(str) {
        if (str) {
            return str.replace(
                /\w\S*/g,
                function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
            );
        }
    }
    function getData() {
        uicontext.showLoader(true);
        resources.getRegions(region.codigoRegion).then((result) => {
            let woman = 0;
            let man = 0;
            if (result.data == null || result.data.length == 0) { uicontext.hideLoader(); return; }

            result.data.map((c) => {
                if (c.nroMujeres) { woman += c.nroMujeres }
                if (c.nroHombres) { man += c.nroHombres }
                if (c.caletaPOS != '-') {
                    c.caletaPOS = JSON.parse(c.caletaPOS)
                } else {
                    c.caletaPOS = [-70.665975, -33.440324]
                }
            })
            setWoman(woman)
            setMan(man)
            selectCaleta(result.data[0], false)
            setCaletas(result.data)
            setIsCharged(true);
            uicontext.hideLoader();
        }).catch((err) => {
            console.warn({error: err})
        })
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <div className="regionSelectedMainContainer">
            <div style={{ backgroundImage: `url(${require("../../../assets/mapa/" + region.photo)})` }} className="regionSelectedHeader">
                <div style={{ backgroundColor: `#${region.color}` }} className="regionNameContainer" onClick={() => {
                    setShowCaleta(false);
                }}>
                    <span>Región {region.name}</span>
                </div>

                <div className="regionDataContainer">
                    <div className="item">
                        <span className="data">{caletas.length}</span>
                        <span className="label">Caletas</span>
                    </div>
                    <div className="item">
                        <span className="data">{woman + man}</span>
                        <span className="label">Pescadores</span>
                    </div>
                    <div className="item">
                        <span className="data">{woman}</span>
                        <span className="label">Mujeres</span>
                    </div>
                    <div className="item">
                        <span className="data">{man}</span>
                        <span className="label">Hombres</span>
                    </div>
                </div>
            </div>

            <div className="caletaSelector">
                {showCaletasList == false &&
                    <div className="itemGrid" onClick={() => { setShowCaletasList(true); }}>
                        <span> {caleta.nombreCaleta} </span>
                        <img className="arrow" src={flecha} alt="Arrow" />
                    </div>
                }

                {
                    showCaletasList == true && caletas.map((c) => {
                        c.nombreCaleta = c.nombreCaleta.toUpperCase();
                        return (
                            <div key={c.nombreCaleta} className="itemGrid" onClick={() => { selectCaleta(c, false); }}>
                                <span> {toTitleCase(c.nombreCaleta)} </span>
                                <img className="arrow flipArrow" src={flecha} alt="Arrow" />
                            </div>
                        )
                    })
                }


            </div>

            <div className="caletaDetailsContainer">
                <div className="itemGrid" onClick={() => {
                    setShowCaleta(true);
                    setCaletaId(caleta.cdCaleta);
                }}>
                    <span> Conoce nuestra caleta </span>
                </div>
            </div>

            {showCaleta == false && <div className="mapContainer">
                <LeafletMap zoom={10} zoomConmutator={false} /*geoRestrictions={GeoRestrictions}*/ markerPosition={markerPosition} />
            </div>}

            {
                showCaleta && (
                    <CaletaSelected caleta={caleta} id={caleta.codigoCaleta} region={region.codigoRegion} />
                )
            }

            { !showCaleta && <FisherPortal />}
        </div>

    )
}

export default RegionSelected;
